import { MMGatewayClient } from '../MMGatewayClient';

export class CuscomService extends MMGatewayClient {
  public async acceptNotifications() {
    return this.put(
      'cuscom/v2/user/permissions',
      {
        application: 'loyalty',
        calls: true,
        digital_receipt: false, // Чеки - для них нужна подтверждённая почта
        email: true,
        push_content: true,
        push_mass: true,
        push_pers: true,
        sms: true,
        social: true,
      },
      {
        headers: {
          'X-Source': 'auth-profile-filling',
        },
      }
    );
  }
}
